module.exports = __webpack_public_path__ + "media/sfx_click_6.7195ed31.wav";